module.exports = __webpack_public_path__ + "static/media/em-221.54c4e0e2.png";